import { NotificationRuleRequest } from "@shared/dtos/requests/notificationRequests.dto"
import {
  NotificationRuleCreationResponse,
  NotificationRuleResponse,
} from "@shared/dtos/responses/notificationResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getAll = async (practiceId: string): Promise<NotificationRuleResponse[]> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/notifications`,
    method: "get",
  })
  return resp.data
}

export const create = async (
  practiceId: string,
  req: NotificationRuleRequest
): Promise<NotificationRuleCreationResponse> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/notifications`,
    method: "post",
    data: req,
  })
  return resp.data
}

export const edit = async (
  practiceId: string,
  notificationRuleId: string,
  req: NotificationRuleRequest
): Promise<void> => {
  await axiosAuth({
    url: `/practices/${practiceId}/notifications/${notificationRuleId}`,
    method: "put",
    data: req,
  })
  return undefined
}

export const remove = async (practiceId: string, notificationRuleId: string): Promise<void> => {
  await axiosAuth({
    url: `/practices/${practiceId}/notifications/${notificationRuleId}`,
    method: "delete",
  })
  return undefined
}
